import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { Account } from "../generated/types";
import { I18nKey } from "../i18n/i18n";
import { isAssistant, Space, spaceForType } from "./roles";

// Un compte est rangé dans l'espace de son type : les assistants rejoignent ainsi leur type
// principal, et un type inconnu tombe dans le support plutôt que de disparaître. Les groupes
// s'affichent dans cet ordre.
const GROUPS: { space: Space; label: I18nKey; icon: IconProp }[] = [
  // i18n.t("account-group-breeders")
  { space: "breeder", label: "account-group-breeders", icon: "seedling" },
  // i18n.t("account-group-installers")
  {
    space: "installer",
    label: "account-group-installers",
    icon: "screwdriver-wrench",
  },
  // i18n.t("account-group-groups")
  { space: "group", label: "account-group-groups", icon: "users" },
  // i18n.t("account-group-support")
  { space: "admin", label: "account-group-support", icon: "user-shield" },
];

/**
 * Comptes rangés par espace, titulaires avant assistants, groupes vides retirés, chaque
 * compte une seule fois.
 */
export const groupAccounts = (accounts: Account[]) => {
  const unique = accounts.filter(
    (account, index) =>
      accounts.findIndex((other) => other.id === account.id) === index
  );
  const ordered = [
    ...unique.filter((account) => !isAssistant(account.type)),
    ...unique.filter((account) => isAssistant(account.type)),
  ];
  return GROUPS.map((group) => ({
    ...group,
    accounts: ordered.filter(
      (account) => spaceForType(account.type) === group.space
    ),
  })).filter((group) => group.accounts.length > 0);
};
